export const daysData = [
    {
        day: 1,
        title: "Data Engineering Fundamentals & ETL",
        topics: [
            "Role of Data Engineer vs Data Scientist",
            "Modern Data Architecture",
            "ETL/ELT Fundamentals",
            "Apache Airflow Basics"
        ]
    },
    {
        day: 2,
        title: "Databases & Advanced SQL",
        topics: [
            "Advanced SQL Operations",
            "Database Design",
            "Performance Optimization",
            "Practical Exercises"
        ]
    },
    {
        day: 3,
        title: "Big Data & Distributed Processing",
        topics: [
            "Big Data Fundamentals",
            "Apache Spark Architecture",
            "Data Processing at Scale",
            "Performance Tuning"
        ]
    }
];